import BoilerGas from '../../../fields/icon/icons/heating-circuits/boiler-gas.svg';
export const defaultIconCard = BoilerGas;
